export type CardDataProps = {
  id: number;
  name: string;
  content: string;
  rate: number;
};

const testimonials: CardDataProps[] = [
  {
    id: 1,
    name: 'Anna T.',
    rate: 5,
    content:
      "I had a collection of old, faded family photos that I thought were beyond repair. Kaze AI restored them beautifully, bringing back details I hadn't seen in years. It felt like reconnecting with history!",
  },
  {
    id: 2,
    name: 'James P.',
    rate: 5,
    content:
      "Clients often bring me old, damaged photos hoping for a miracle. With Kaze AI, I can restore them instantly, keeping textures and details intact. It's now an essential part of my workflow!",
  },
  {
    id: 3,
    name: 'Laura M.',
    rate: 5,
    content:
      "Researching my family tree meant dealing with blurry and damaged photos. Kaze AI restored them so well that I could finally see my ancestors' faces clearly. It's absolutely incredible!",
  },
  {
    id: 4,
    name: 'Kevin D.',
    rate: 5,
    content:
      'We handle a lot of historical photographs that have suffered damage over time. Kaze AI allows us to digitally restore them without losing authenticity, preserving history for future generations.',
  },
  {
    id: 5,
    name: 'Sarah L.',
    rate: 5,
    content:
      'I work with vintage-style content, and many of the photos I use need restoration. Kaze AI does it instantly, making every image crisp, clear, and perfect for sharing online.',
  },
  {
    id: 6,
    name: 'Michael R.',
    rate: 5,
    content:
      "I love creating scrapbooks with old photos, but some were too damaged to use. Kaze AI restored them beautifully, making my family albums even more special. It's truly magical!",
  },
];

export default testimonials;
